import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByCreativeCSV from './StatisticsByCreativeCSV';
import {
    getData,
    getHeaderName
} from './StatisticsByCreativeCSV.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: getData,
    headerName: getHeaderName
});

const StatisticsByCreativeCSVComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByCreativeCSV);

export default StatisticsByCreativeCSVComponent;
